var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"elevation":"2"}},[_c('v-card-title',{staticClass:"text-h5"},[_vm._v(" Models ")]),_c('v-card-text',[_vm._v(" TODO: add models ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }